/**
 * @file tooltip.js
 */
'use strict';

exports.__esModule = true;

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _component = require('./component');

var _component2 = _interopRequireDefault(_component);

var _utilsDomJs = require('./utils/dom.js');

var Dom = _interopRequireWildcard(_utilsDomJs);

var _utilsEventsJs = require('./utils/events.js');

var Events = _interopRequireWildcard(_utilsEventsJs);

var _utilsFnJs = require('./utils/fn.js');

var Fn = _interopRequireWildcard(_utilsFnJs);

var _globalDocument = require('global/document');

var _globalDocument2 = _interopRequireDefault(_globalDocument);

var _lodashCompatFunctionThrottle = require('lodash-compat/function/throttle');

var _lodashCompatFunctionThrottle2 = _interopRequireDefault(_lodashCompatFunctionThrottle);

/**
 * Base class for all tooltips
 *
 * @param {Object} player  Main Player
 * @param {Object=} options Object of option names and values
 * @extends Component
 * @class Tooltip
 */

var Tooltip = (function (_Component) {
  _inherits(Tooltip, _Component);

  function Tooltip(player, options) {
    _classCallCheck(this, Tooltip);

    _Component.call(this, player, options);

    this.handleHover_ = _lodashCompatFunctionThrottle2['default'](Fn.bind(this, this.handleHover), 25);
    this.handleLeave_ = _lodashCompatFunctionThrottle2['default'](Fn.bind(this, this.handleLeave), 25);
  }

  Tooltip.prototype.createEl = function createEl() {
    return _Component.prototype.createEl.call(this, 'div', {
      className: 'vjs-tooltip'
    });
  };

  Tooltip.prototype.text = function text(_text) {
    if (!_text) return this.text_ || '';

    this.text_ = _text;
    this.el_.innerHTML = this.localize(this.text_);

    this.update();

    return this;
  };

  Tooltip.prototype.handler = function handler(_handler) {
    if (!_handler) return this.handler;

    if (this.handler_) {
      this.off(this.handler_, 'mouseover', this.handleHover_);
      this.off(this.handler_, 'mouseout', this.handleLeave_);
    }

    this.handler_ = _handler;
    this.on(this.handler_, 'mouseover', this.handleHover_);
    this.on(this.handler_, 'mouseout', this.handleLeave_);

    return this;
  };

  Tooltip.prototype.handleHover = function handleHover() {
    var _this = this;

    if (this.timeout) {
      this.clearTimeout(this.timeout);
      this.timeout = 0;
    }
    this.timeout = this.setTimeout(function () {
      return _this.hide();
    }, 1000);
    this.show();
  };

  Tooltip.prototype.handleLeave = function handleLeave(event) {
    var _this2 = this;

    if (this.timeout) {
      this.clearTimeout(this.timeout);
      this.timeout = 0;
    }
    this.timeout = this.setTimeout(function () {
      return _this2.hide();
    }, 50);
  };

  Tooltip.prototype.show = function show() {
    var _this3 = this;

    this.player_.trigger('tooltipShown');
    this.player_.on('tooltipShown', function () {
      return _this3.hide();
    });

    this.addClass('vjs-tooltip-active');
    this.update();
  };

  Tooltip.prototype.hide = function hide() {
    this.removeClass('vjs-tooltip-active');

    this.player_.off('tooltipShown');
  };

  Tooltip.prototype.update = function update() {
    var width = this.width();

    if (!width) {
      return this;
    }

    var parent_ = this.handler_;
    var parentWidth = parent_ ? parent_.offsetWidth : 0;

    var parentLeft = Dom.findElPosition(parent_).left - Dom.findElPosition(this.player_.el()).left;
    var skew = parentWidth / 2 - width / 2;

    var minSkew = -parentLeft;
    // TODO: player_.width() is not working properly after switch to fullscreen
    var maxSkew = this.player_.el().offsetWidth - parentLeft - width;

    skew = Math.min(Math.max(minSkew, skew), maxSkew);

    this.el_.style.left = skew + 'px';

    return this;
  };

  return Tooltip;
})(_component2['default']);

_component2['default'].registerComponent('Tooltip', Tooltip);
exports['default'] = Tooltip;
module.exports = exports['default'];
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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